import React, { useEffect, useState } from 'react'
import { BaseModalV3 } from 'components/ui/BaseModal'
import { Button } from 'components/ui'
import { useAiCreationText } from '../../hooks/useAiCreationText'
import styles from './styles.module.css'

export function AIResetDialog({ onCancel, onConfirm }: { onCancel: () => void; onConfirm: () => void }) {
  const [acknowledged, setAcknowledged] = useState(false)
  const t = useAiCreationText()

  useEffect(() => {
    const cancel = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return
      event.preventDefault()
      event.stopImmediatePropagation()
      onCancel()
    }
    document.addEventListener('keydown', cancel, true)
    return () => document.removeEventListener('keydown', cancel, true)
  }, [onCancel])

  return (
    <BaseModalV3
      isOpen
      onClose={onCancel}
      trapFocus
      closeOnOverlayClick
      contentProps={{
        style: {
          width: 'calc(100vw - 32px)',
          minWidth: 0,
          maxWidth: 600,
          height: 'auto',
          zIndex: 10001,
          borderRadius: 22,
          outline: 'none',
        },
      }}
      headerProps={{ style: { padding: '28px 30px 10px', boxShadow: 'none', fontSize: 22 } }}
      bodyProps={{ style: { height: 'auto', padding: '0 30px 26px', background: 'white' } }}
      footerProps={{
        style: {
          justifyContent: 'flex-end',
          padding: '20px 30px',
          background: '#fafbfc',
          borderTop: '1px solid #edf0f2',
        },
      }}
      header={<strong>{t.resetTitle}</strong>}
      body={
        <div className={styles.body}>
          <p>{t.resetHint}</p>
          <label>
            <input type="checkbox" checked={acknowledged} onChange={(event) => setAcknowledged(event.target.checked)} />
            {t.resetAcknowledge}
          </label>
        </div>
      }
      footer={
        <div className={styles.actions}>
          <Button type="button" variant="secondary" fontSize="16px" height="44px" onClick={onCancel}>
            {t.cancel}
          </Button>
          <Button
            type="button"
            variant="danger"
            bg="#c6422d"
            fontSize="16px"
            height="44px"
            isDisabled={!acknowledged}
            onClick={onConfirm}
          >
            {t.remove}
          </Button>
        </div>
      }
    />
  )
}
